import {QueryClient, QueryClientProvider} from 'react-query';
import {SkeletonTheme} from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import ReactModal from 'react-modal';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
import {config} from './config';

ReactModal.setAppElement('#root');

const queryClient = new QueryClient();

/**
 *  Setup client context, though the children are most likely server components
 */
export default function ClientApp({children}) {
  return (
    <QueryClientProvider client={queryClient}>
      <GoogleReCaptchaProvider reCaptchaKey={config.gReCaptchaKey}>
        <SkeletonTheme borderRadius={4}>{children}</SkeletonTheme>
      </GoogleReCaptchaProvider>
    </QueryClientProvider>
  );
}
